/* __next_internal_client_entry_do_not_use__ OtherInfo auto */import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslations } from "next-intl";
import Image from "next/image";
import facebook from "@/assets/image/facebook.webp";
import instagram from "@/assets/image/instagram.webp";
import twitter from "@/assets/image/twitter.webp";
import { getDetailUrl, getUpdateTime } from "@/helpers/blog";
import { IMG_COMPRESS_SUFFIX } from "@/components/features/common/constant";
export const OtherInfo = param => {
  let {
    readMoreList,
    updateDate
  } = param;
  const t = useTranslations();
  const handleTime = getUpdateTime(updateDate);
  function getMetaContent(name) {
    const metaTag = document.querySelector('meta[name="'.concat(name, '"]'));
    return metaTag ? metaTag.getAttribute("content") : null;
  }
  function shareOnTwitter(platform) {
    const url = window.location.href;
    const text = getMetaContent("description") || "";
    const hashtags = getMetaContent("keywords") || "";
    let intentUrl = "";
    if (platform === "facebook") {
      intentUrl = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url));
    } else if (platform === "twitter") {
      intentUrl = "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(text), "&url=").concat(encodeURIComponent(url), "&hashtags=").concat(encodeURIComponent(hashtags));
    } else {
      intentUrl = "http://www.linkedin.com/shareArticle?mini=true&title=".concat(encodeURIComponent("".concat(text, "#").concat(hashtags)), "&url=").concat(encodeURIComponent(url));
    }
    window.open(intentUrl, "_blank", "width=550,height=420");
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "other-articles",
      children: [/*#__PURE__*/_jsx("div", {
        className: "other-articles-title",
        children: t("Seo_Main_Bottom_ReadMore")
      }), /*#__PURE__*/_jsx("ul", {
        className: "other-articles-list",
        children: readMoreList === null || readMoreList === void 0 ? void 0 : readMoreList.map((item, index) => {
          return /*#__PURE__*/_jsx("li", {
            className: "other-article",
            children: /*#__PURE__*/_jsx("a", {
              href: getDetailUrl(item.urlName, item.language),
              target: "_blank",
              children: item.title
            })
          }, index);
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "article-info",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "article-info-item",
        children: [/*#__PURE__*/_jsx("div", {
          className: "article-info-title",
          children: t("Seo_Main_Bottom_Writter")
        }), /*#__PURE__*/_jsxs("div", {
          className: "article-info-content",
          children: [/*#__PURE__*/_jsx("img", {
            width: "28",
            src: "https://txcdn-prod-a1art.xiaopiu.com/static/png/favicon-0bb46f45.png" + IMG_COMPRESS_SUFFIX,
            alt: ""
          }), /*#__PURE__*/_jsx("p", {
            children: "a1.art"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "article-info-item",
        children: [/*#__PURE__*/_jsx("div", {
          className: "article-info-title",
          children: t("Seo_Main_Bottom_Published")
        }), /*#__PURE__*/_jsx("div", {
          className: "article-info-content article-time",
          children: /*#__PURE__*/_jsx("p", {
            children: handleTime
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "article-info-item",
        children: [/*#__PURE__*/_jsx("div", {
          className: "article-info-title",
          children: t("Seo_Main_Bottom_Share")
        }), /*#__PURE__*/_jsxs("div", {
          className: "article-info-content",
          children: [/*#__PURE__*/_jsx("div", {
            className: "article-share-item",
            "data-platform": "facebook",
            onClick: () => {
              shareOnTwitter("facebook");
            },
            children: /*#__PURE__*/_jsx(Image, {
              width: "28",
              src: facebook,
              alt: "facebook"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "article-share-item",
            "data-platform": "twitter",
            onClick: () => {
              shareOnTwitter("twitter");
            },
            children: /*#__PURE__*/_jsx(Image, {
              width: "28",
              src: twitter,
              alt: "twitter"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "article-share-item",
            "data-platform": "linkedin",
            onClick: () => {
              shareOnTwitter("linkedin");
            },
            children: /*#__PURE__*/_jsx(Image, {
              width: "28",
              src: instagram,
              alt: "linkedin"
            })
          })]
        })]
      })]
    })]
  });
};